import { serverAxiosPromise } from '@alltrails/shared/utils/requests/requestBase';

import { Alert, AlertId, AlgoliaAlert } from '../../types/alerts';
import { AreaId } from '../../types/areas';
import { TrailId } from '../../types/trails';

type TrailsAlertCreateRequestPayload = {
  area_id?: AreaId;
  trail_ids?: TrailId[];
  alert: Alert;
};

type TrailsAlertUpdateRequestPayload = {
  areaId: AreaId;
  alert: Alert;
  trailIds?: TrailId[];
};

type TrailsAlertDeleteRequestPayload = {
  areaId: AreaId;
  alert: AlgoliaAlert;
  trailIds: TrailId[];
};

type TrailsAlertResponse = Alert & {
  trailIds: TrailId[];
};

const createAlertRequest = async (alertPayload: TrailsAlertCreateRequestPayload): Promise<TrailsAlertResponse[]> => {
  const url = `/api/alltrails/trails/alerts`;
  const method = 'POST';

  const { data } = await serverAxiosPromise({ url, method, data: alertPayload });
  return data;
};

const updateAlertRequest = async (alertPayload: TrailsAlertUpdateRequestPayload): Promise<TrailsAlertResponse> => {
  const url = `/api/alltrails/admin/alerts`;
  const method = 'POST';
  const payload = {
    type: 'area',
    id: alertPayload.areaId,
    alert: alertPayload.alert,
    trail_ids: alertPayload.trailIds
  };

  const { data } = await serverAxiosPromise({ url, method, data: payload });
  return data;
};

const deleteAlertRequest = async (alertPayload: TrailsAlertDeleteRequestPayload): Promise<TrailsAlertResponse> => {
  const method = 'POST';
  const url = '/api/alltrails/admin/alerts';

  const payload = {
    id: alertPayload.areaId,
    type: 'area',
    alert: {
      id: alertPayload.alert.ID,
      deleted: true
    }
  };

  const { data } = await serverAxiosPromise({ url, method, data: payload });
  return data;
};

const getAlertRequest = async (id: AlertId): Promise<Alert[]> => {
  const url = `/api/alltrails/alerts/${id}`;

  const { data } = await serverAxiosPromise({ url });
  return data;
};

export {
  TrailsAlertCreateRequestPayload,
  TrailsAlertUpdateRequestPayload,
  TrailsAlertDeleteRequestPayload,
  TrailsAlertResponse,
  createAlertRequest,
  updateAlertRequest,
  deleteAlertRequest,
  getAlertRequest
};
